import './dialler.scss';
import React, { PureComponent, RefObject } from 'react';

import Answer from './buttons/Answer-Button.svg';
import KeypadBtn from './buttons/Keypad-Button.svg';
import { TriggeredPopup, Form } from '@missionlabs/smartagent-app-components';
import Keypad from './Keypad';
import { connect } from 'react-redux';
import RootState from 'store/state';
import { setNumberDialling } from 'store/global/global.actions';
import { IMakeCall } from 'store/call/call.actions';
import { getBodyWidth } from 'utils';
import QuickDialler from 'views/QuickDialler';
import { HomeContext } from 'views/Home'
import { removeInvalidCharacters } from 'utils'
import { DialerControlButton } from 'components';

interface Props extends ReturnType<typeof mapStateToProps> {
    makeCall: IMakeCall;
    setNumberDialling: typeof setNumberDialling
}

interface State {

}

class Controls extends PureComponent<Props, State> {

    private numberInput: RefObject<HTMLInputElement> | null | undefined = React.createRef();

    readonly state = {
        isKeypadShown: false,
    };

    onChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
        this.props.setNumberDialling(
            ev.target.value
        )
    };
    onCall = () => {
        if (!this.props.number || this.props.disabled) return;
        // remove invalid characters before making the call 
        const cleanNumber = removeInvalidCharacters(this.props.number)

        this.props.makeCall(cleanNumber);
    };

    onKeypadButton = (val: string) => {
        this.props.setNumberDialling(
            this.props.number + val
        )
    };

    render() {
        return (
            <HomeContext.Consumer>
                {({ setDiallerOpened }) => (
                    <Form className="dialler-keypad" onSubmit={this.onCall}>
                        <input
                            ref={this.numberInput}
                            title="Enter number"
                            className="remote-number"
                            type="text"
                            placeholder="Enter number..."
                            value={this.props.number}
                            onChange={this.onChange}
                            onBlur={this.onChange} // For speech to text purposes, the onChange event is not triggered on input
                        />
                        <div className="dialler-controls">

                            <QuickDialler channel="VOICE" />

                            <TriggeredPopup
                                closeOnClickOutside
                                onOpen={() => {
                                    this.setState({ isKeypadShown: true })
                                    setDiallerOpened?.(true)
                                }}
                                onClose={() =>
                                    this.setState({ isKeypadShown: false })
                                }
                                noShadow
                                fromCenter={getBodyWidth() > 500}
                                className='dialler-popup'
                                trigger={
                                    <DialerControlButton
                                        disabled={this.props.disabled}
                                        className='keypad white-button'
                                        isFocused={this.state.isKeypadShown}
                                        type="button"
                                    >
                                        <img
                                            src={KeypadBtn}
                                            alt='Keypad'
                                            title='Keypad'
                                        />
                                    </DialerControlButton>
                                }
                            >
                                <Keypad onKeypadButton={this.onKeypadButton} />
                            </TriggeredPopup>

                            <DialerControlButton
                                disabled={
                                    this.props.disabled || !this.props.number
                                }
                                elastic
                            >
                                <img src={Answer} alt="Dial" title="Dial" width="40" height="40" />
                            </DialerControlButton>
                        </div>
                    </Form>
                )}
            </HomeContext.Consumer>
        )
    }
}

function mapStateToProps(state: RootState) {

    return {
        number: state.global.numberDialling,
        disabled: !state.user
    }
}

export default connect(mapStateToProps, { setNumberDialling })(Controls)